export default __webpack_public_path__ + "static/media/open.8cbec530.svg";